/* ─────────────────────────────────────────────────────────────────────────────────────────────
   IAS · ias.js — the ONE documented IAS script (REPAIR 1, 2026-10-17). Works WITH Dawn, never around it.
   Later repair steps move the rest of the IAS code in here, one change per publish.

   § 1 · ONE ADD PATH — IAS.add(items, opts)
   Every IAS add button (chord shelf, chord builder, key room) adds through here, using Dawn's own pieces:
     • Dawn's route (routes.cart_add_url) and Dawn's bundled sections (cart-drawer + cart-icon-bubble)
     • Dawn's drawer: cart-drawer.open() and cart-drawer.renderContents() (refreshes the drawer AND the header count)
     • Dawn's event bus: publish(PUB_SUB_EVENTS.cartUpdate, …), the same event Dawn's own product form sends
   Timing: Shopify takes ~0.6–1.7 s to answer an add, so the drawer opens AT THE TAP with "Adding …" and switches to
   "Added ✓" when Shopify answers. Errors use Shopify's own words: no reload, no red banner.
   Safety (KOSH-FIX+ rule kept): a dropped reply is retried once only if nothing landed, so an add never doubles.

   opts: { button, label: 'D Major · 432 Hz', source: 'chord-shelf', before: {variantId: qty} (cart before the tap),
           busyText, doneText, onDone(result) }
   returns Promise<{ ok, status, description }>
   ───────────────────────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var IAS = (window.IAS = window.IAS || {});
  var FLASH_MS = 2600;

  function drawer() { return document.querySelector('cart-drawer'); }
  function addUrl() { return (window.routes && window.routes.cart_add_url) || '/cart/add'; }
  function cartUrl() { return (window.routes && window.routes.cart_url) || '/cart'; }
  function sectionIds(dr) { return dr && dr.getSectionsToRender ? dr.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble']; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function qtyMap(cart) { var m = {}; ((cart && cart.items) || []).forEach(function (i) { m[i.variant_id] = (m[i.variant_id] || 0) + i.quantity; }); return m; }

  /* ── the status line at the top of Dawn's drawer (re-pinned after every Dawn re-render) ── */
  var flashState = null;
  function pinFlash() {
    var dr = drawer(); if (!dr || !flashState) return;
    var inner = dr.querySelector('.drawer__inner'); if (!inner) return;
    var el = inner.querySelector(':scope > .ias-add-flash');
    if (!el) { el = document.createElement('p'); el.className = 'ias-add-flash'; el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); inner.insertBefore(el, inner.firstChild); }
    el.dataset.state = flashState.state;
    el.textContent = flashState.text;
  }
  function flash(state, text) {
    flashState = { state: state, text: text };
    var dr = drawer(); if (dr) dr.classList.toggle('ias-adding', state === 'adding');
    pinFlash();
    clearTimeout(flash.t);
    if (state !== 'adding') flash.t = setTimeout(function () {
      flashState = null; var d = drawer(); var el = d && d.querySelector('.ias-add-flash'); if (el) el.remove();
    }, state === 'error' ? 8000 : FLASH_MS * 2);
  }

  /* ── the button's own feedback ── */
  function buttonState(b, state, text) {
    if (!b) return;
    if (!b.dataset.iasLabel) b.dataset.iasLabel = b.innerHTML;
    b.dataset.iasState = state;
    if (state === 'adding') { b.disabled = true; b.setAttribute('aria-busy', 'true'); b.textContent = text || 'Adding…'; }
    else if (state === 'added') { b.disabled = false; b.removeAttribute('aria-busy'); b.textContent = text || 'Added ✓'; }
    else { b.disabled = false; b.removeAttribute('aria-busy'); b.innerHTML = b.dataset.iasLabel; delete b.dataset.iasLabel; delete b.dataset.iasState; }
  }

  /* ── network: Dawn's route + Dawn's sections, in one request ── */
  function post(items) {
    var dr = drawer();
    return fetch(addUrl(), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sectionIds(dr), sections_url: location.pathname })
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && !j.status, status: j.status || r.status, j: j }; });
    }, function () { return { ok: false, status: 0, j: {} }; });
  }
  IAS.cart = function () { return fetch(cartUrl() + '.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); };
  /* re-render Dawn's drawer + header count without adding (used when an add landed but its reply was lost) */
  IAS.refresh = function () {
    var dr = drawer();
    return fetch(location.pathname + '?sections=' + sectionIds(dr).join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) { if (sections) render({ sections: sections }); return sections; })
      .catch(function () { return null; });
  };
  function render(state, source, firstId) {
    var dr = drawer();
    if (dr && dr.renderContents && state && state.sections) { dr.renderContents(state); dr.classList.remove('is-empty'); setTimeout(pinFlash, 0); }
    try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: source || 'ias', productVariantId: firstId, cartData: state }); } catch (e) {}
    /* legacy IAS listeners still read this; the consolidation step moves them onto Dawn's cartUpdate and retires it */
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: source || 'ias' } }));
  }
  function landed(cart, before, items) {
    if (!cart || !before) return false; var m = qtyMap(cart);
    return items.every(function (it) { return (m[it.id] || 0) >= (before[it.id] || 0) + (it.quantity || 1); });
  }

  IAS.add = function (items, opts) {
    opts = opts || {};
    items = (items || []).map(function (it) { return { id: parseInt(it.id, 10), quantity: it.quantity || 1, properties: it.properties }; })
      .filter(function (it) { return it.id; });
    if (!items.length) return Promise.resolve({ ok: false, status: 0, description: '' });
    var b = opts.button, label = opts.label || '', dr = drawer();
    if (b && b.dataset.iasState === 'adding') return Promise.resolve({ ok: false, status: 0, busy: true });
    /* 1 · at the tap: button + drawer say "Adding …" right away */
    buttonState(b, 'adding', opts.busyText);
    flash('adding', 'Adding ' + (label || 'to your bag') + '…');
    if (dr && dr.open) { if (b) dr.setActiveElement && dr.setActiveElement(b); dr.open(b); }
    /* 2 · Shopify (one retry, only when nothing landed) */
    return post(items).then(function (res) {
      if (res.ok || !(res.status === 0 || res.status >= 500)) return res;
      return IAS.cart().then(function (c) {
        if (landed(c, opts.before, items)) return IAS.refresh().then(function () { return { ok: true, status: 200, j: null, refreshed: true }; });
        if (!opts.before) return res;                      // can't prove nothing landed → never risk a double add
        return wait(700).then(function () { return post(items); });
      });
    }).then(function (res) {
      /* 3 · answer: Dawn re-renders the drawer + header count; "Added ✓" on both */
      if (res.ok) {
        if (!res.refreshed) render(res.j, opts.source, items[0].id);
        flash('added', 'Added ✓ ' + label);
        buttonState(b, 'added', opts.doneText || 'Added ✓');
        setTimeout(function () { buttonState(b, 'idle'); if (opts.onSettle) opts.onSettle(); }, FLASH_MS);
      } else {
        var why = (res.j && (res.j.description || res.j.message)) || 'That didn’t go through. Tap once more.';
        flash('error', why);
        buttonState(b, 'idle');
      }
      var out = { ok: !!res.ok, status: res.status, description: res.ok ? '' : ((res.j && res.j.description) || '') };
      if (opts.onDone) opts.onDone(out);
      return out;
    });
  };
  IAS.post = post;
  IAS.render = render;

  /* § 2 · HEADER COUNT TRUTH — the bag count in the header always equals the real cart.
     Dawn writes it from Shopify's reply (always right). A third-party app (Redo, getredo.com) rewrites it a few seconds
     later from its own older copy of the cart, so a shopper could see "1" with 2 flutes in the bag. After ANY write to
     the header count, read the cart once; if they disagree, re-render Dawn's own cart-icon-bubble section. */
  function shownCount() { var s = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]'); return s ? (parseInt(s.textContent, 10) || 0) : 0; }
  var bubbleT = 0, bubbleBusy = false;
  function bubbleCheck() {
    if (bubbleBusy) return; bubbleBusy = true;
    IAS.cart().then(function (c) {
      if (!c || c.item_count === shownCount()) return;
      return fetch(location.pathname + '?sections=cart-icon-bubble', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (sec) {
          var host = document.getElementById('cart-icon-bubble'), html = sec && sec['cart-icon-bubble'];
          var fresh = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (host && fresh) host.innerHTML = fresh.innerHTML;
        });
    }).catch(function () {}).then(function () { setTimeout(function () { bubbleBusy = false; }, 600); });
  }
  function watchBubble() {
    var host = document.getElementById('cart-icon-bubble'); if (!host) return;
    new MutationObserver(function () { clearTimeout(bubbleT); bubbleT = setTimeout(bubbleCheck, 500); })
      .observe(host, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBubble); else watchBubble();
})();
